/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PublishDraftRequest
 */
export interface PublishDraftRequest {
    /**
     * 
     */
    changelog?: string;
    /**
     * 
     */
    publishedBy?: string;
}

/**
 * Check if a given object implements the PublishDraftRequest interface.
 */
export function instanceOfPublishDraftRequest(value: object): value is PublishDraftRequest {
    return true;
}

export function PublishDraftRequestFromJSON(json: any): PublishDraftRequest {
    return PublishDraftRequestFromJSONTyped(json, false);
}

export function PublishDraftRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublishDraftRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'changelog': json['changelog'] == null ? undefined : json['changelog'],
        'publishedBy': json['publishedBy'] == null ? undefined : json['publishedBy'],
    };
}

export function PublishDraftRequestToJSON(json: any): PublishDraftRequest {
    return PublishDraftRequestToJSONTyped(json, false);
}

export function PublishDraftRequestToJSONTyped(value?: PublishDraftRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'changelog': value['changelog'],
        'publishedBy': value['publishedBy'],
    };
}

